<div class="modal-header" mat-dialog-title>
    <div class="modal-header-icon">
        <mat-icon>data_object</mat-icon>
    </div>
    <div class="modal-header-titles">
        <h2 class="modal-title">Variáveis disponíveis</h2>
    </div>
    <div class="modal-header-close-btn-container">
        <button mat-icon-button type="button" class="modal-close-btn" (click)="fechar()">
            <mat-icon class="material-symbols-outlined">close</mat-icon>
        </button>
    </div>
</div>

<mat-dialog-content class="modal-content">
    <div class="dialog-layout">

        <!-- Filtros (acima) -->
        <div class="filtros-row">
            <mat-form-field appearance="outline" class="busca-field" subscriptSizing="dynamic">
                <mat-label>Pesquisar variável</mat-label>
                <input matInput [formControl]="searchControl" placeholder="Nome, código, descrição...">
                <mat-icon matSuffix>search</mat-icon>
            </mat-form-field>

        </div>

        <!-- Tabela (abaixo) ou Cards (se estreito) -->
        <div class="tabela-col">
            @if (isNarrow) {
            <div class="modal-card-list">
                @for (v of variavelFiltradas; track variavelChave(v)) {
                <div class="modal-card variavel-row"
                    [class.row-selecionada]="variavelSelecionada === v"
                    (click)="selecionarVariavel(v)">
                    <div class="modal-card__header">
                        <span class="status-badge badge-variavel" [ngClass]="classeBadgeVariavel(v)" [attr.data-chave]="variavelChave(v)">
                            @if (isVariavelParametro(v)) { <span class="material-symbols-outlined" aria-label="Parâmetro de configuração" title="Parâmetro de configuração">settings</span> }
                            @if (v.possuiFormulaAplicavel) { <span class="material-symbols-outlined" aria-label="Possui fórmula aplicável" title="Possui fórmula aplicável">function</span> }
                            <span class="variavel-badge-descricao">{{ v.descricao }}</span>
                            <span class="variavel-badge-nome">{{ '{' + v.nome + '}' }}</span>
                        </span>
                    </div>
                    <div class="modal-card__body">
                        <div class="modal-card__ro">
                            <small>Observação</small>
                            <span>{{ v.observacao ?? '—' }}</span>
                        </div>
                        <div class="modal-card__ro">
                            <small>Chave</small>
                            <span>{{ variavelChave(v) }}</span>
                        </div>
                        @if (v.pathTagXml) {
                        <div class="modal-card__ro">
                            <small>Path XML</small>
                            <span>{{ v.pathTagXml }}</span>
                        </div>
                        }
                    </div>
                </div>
                }
            </div>
            } @else {
            <table mat-table [dataSource]="variavelFiltradas" class="variaveis-table w-100">

                <ng-container matColumnDef="variavel">
                    <th mat-header-cell *matHeaderCellDef>Variável</th>
                    <td mat-cell *matCellDef="let v">
                        <span class="status-badge badge-variavel" [ngClass]="classeBadgeVariavel(v)" [attr.data-chave]="variavelChave(v)">
                            @if (isVariavelParametro(v)) { <span class="material-symbols-outlined" aria-label="Parâmetro de configuração" title="Parâmetro de configuração">settings</span> }
                            @if (v.possuiFormulaAplicavel) { <span class="material-symbols-outlined" aria-label="Possui fórmula aplicável" title="Possui fórmula aplicável">function</span> }
                            <span class="variavel-badge-descricao">{{ v.descricao }}</span>
                            <span class="variavel-badge-nome">{{ '{' + v.nome + '}' }}</span>
                        </span>
                    </td>
                </ng-container>

                <ng-container matColumnDef="observacao">
                    <th mat-header-cell *matHeaderCellDef>Observação</th>
                    <td mat-cell *matCellDef="let v" class="descricao-col">
                        <div>{{ v.observacao ?? '—' }}</div>
                        <small>Chave: {{ variavelChave(v) }}</small>
                        @if (v.pathTagXml) { <small> · Path XML: {{ v.pathTagXml }}</small> }
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="colunas"></tr>
                <tr mat-row *matRowDef="let row; columns: colunas;"
                    [class.row-selecionada]="variavelSelecionada === row"
                    (click)="selecionarVariavel(row)"
                    class="variavel-row">
                </tr>

            </table>
            }

            @if (variavelFiltradas.length === 0) {
            <app-empty-state
                icon="search_off"
                title="Nenhuma variável encontrada"
                subtitle="Ajuste a pesquisa para encontrar as variáveis desejadas.">
            </app-empty-state>
            }
        </div>
    </div>
</mat-dialog-content>

<mat-dialog-actions class="modal-footer">
    <button mat-stroked-button class="btn-secondary" type="button" (click)="fechar()">Cancelar</button>
    <button mat-flat-button class="btn-primary" type="button"
        [disabled]="!variavelSelecionada"
        (click)="inserirVariavel()">
        <mat-icon>add</mat-icon>
        Inserir variável
    </button>
</mat-dialog-actions>
